import React, { useEffect, useState, useRef } from 'react'
import { useSelector } from 'react-redux';
import { selectData } from '../../../services/store/userSlice';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { timesheetApi } from '../../../services';
import { Dropdown } from 'primereact/dropdown';
import { leaveService } from '../../../services/extensions';
import { Status, LeaveStatus } from '../../../common/util/constants';
import { useLocation } from 'react-router-dom';
import { Util } from '../../../services';
import { toast } from "react-toastify";
import { Dialog } from 'primereact/dialog';
import { utitService } from '../../../services/util';
import '../styles/user-leave.scss';
import { selectUser } from '../../../services/store/userSlice';
import { ViewLeave } from './view-leave';
import ConfirmBox from '../../../components/confirmbox/confirmbox';
import moment from 'moment';


const ManagerUserLeaves = ({ duration }) => {
    const userData = useSelector(selectData);
    const dt = useRef(null);
    const [usersBySuperior, setUsersBySuperior] = useState([]);
    const [selectedUser, setSelectedUser] = useState({});
    const [selectedLeave, setSelectedLeave] = useState([]);
    const [approvedLeavesByEmp, setApprovedLeavesByEmp] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const userId = searchParams.get('id');
    const [reviewRecallLeaves, setReviewRecallLeaves] = useState([]);
    const [selStatus, setSelStatus] = useState('REVIEW');
    const [leaves, setLeaves] = useState([]);
    const [leaveStatuses] = useState(Object.keys(LeaveStatus));
    const [selLeaves, setSelLeaves] = useState({});
    const [viewDialog, setViewDialog] = useState(false);
    const [showDialog, setShowDialog] = useState(false);
    const [action, setAction] = useState('');
    const [viewTabIndex, setViewTabIndex] = useState(0);


    useEffect(() => {
        getUserInfoBySuperiorIdList()
    }, [])

    useEffect(() => {
        if (selectedUser && selStatus) {
            fetchReviewLeavesByUser();
        }
    }, [selectedUser, duration])

    const fetchReviewLeavesByUser = () => {
        leaveService.getAllLeaveByUserId({ id: selectedUser.id, date: moment(duration).format('YYYY-MM-DD') }).then(resp => {
            try {
                setLeaves(resp.data.data);
            } catch (error) {
                //error
            }
        })
    };

    //fetch approved leaves by user
    const fetchApprovedLeavesByUser = () => {
        leaveService.getApprovedLeaves(selectedUser?.id).then(resp => {
            try {
                let approveLeaveArray = []
                approveLeaveArray = resp.data.data?.filter(el => {
                    return el.status === LeaveStatus.APPROVED
                })
                setApprovedLeavesByEmp(approveLeaveArray)
            } catch (error) {
                //error
            }
        })
    };

    //fetch review recalled leaves by user
    const fetchReviewRecallLeaves = () => {
        leaveService.getReviewRecallLeaves(selectedUser?.id).then(resp => {
            try {
                setReviewRecallLeaves(resp.data.data);
            } catch (error) {
                console.log('error');
            }
        })
    }

    /* Users By Superior Data Start */
    const getUserInfoBySuperiorIdList = (param = { "pageNum": 0, "pageSize": 2000 }) => {
        timesheetApi.getUsersBySuperior(param).then((resp) => {
            try {
                const data = resp.data.data;
                const resourceList = data.map((user, index) => ({
                    id: user.id,
                    name: user.firstName.charAt(0).toUpperCase() + user.firstName.slice(1) + " " + user.lastName.charAt(0).toUpperCase() + user.lastName.slice(1).trimEnd(),
                    fullName: user.firstName.charAt(0).toUpperCase() + user.firstName.slice(1) + " " + user.lastName.charAt(0).toUpperCase() + user.lastName.slice(1).trimEnd(),
                })
                );
                setUsersBySuperior(resourceList);
                setSelectedUser(usersBySuperior[0]);
                let activeUser = {};
                if (userId) {
                    activeUser = usersBySuperior.find((i) => i.id === parseInt(userId));
                } else {
                    activeUser = resourceList[0];
                }
                setSelectedUser(activeUser);
            } catch (error) {
                // Error handle
            }
        });
    }
    /* Users By Superior Data End */

    const changeUser = (op) => {
        let updatedUserList = Util.updateUserDropDownList(op, usersBySuperior, selectedUser);
        setSelectedUser(updatedUserList);
    };

    const getEmpDetails = (e) => {
        setSelectedUser(e.value);
    };

    const userOptionTemplate = (data) => {
        return (
            <div className="user-item grid">
                {/* <div className="icon">
                    {data.icon == null ? (
                        <span>{data.name.substr(0, 1)}</span>
                    ) : (
                        <img src={data.icon} />
                    )}
                </div> */}
                <div className="label col">{data.name}</div>
            </div>
        );
    };
    const selectedUserTemplate = (data, props) => {
        if (data) {
            return (
                <div className="user-item user-item-value grid">
                    <div className="icon">
                        {data.icon == null ? (
                            <span>{data.name.substr(0, 1)}</span>
                        ) : (
                            <img src={data.icon} />
                        )}
                    </div>
                    <div className="label col p-2">{data.name}</div>
                </div>
            );
        }
        return <span>{props.placeholder}</span>;
    };
    const renderAbsenceCode = (rowData, options) => {
        // const ac = userData.localAbsenceCodesArray.find(x => x.title == rowData.absenceCode || x.code == rowData.absenceCode);
        return (<>
            <strong>{rowData?.absenceCode}</strong>
            <em> ({rowData?.LeaveAbsenceCode?.title})</em>
        </>)
    }
    const renderAbsenceDuration = (rowData, options) => {
        return (<>
            <strong>{rowData.leaveType}</strong>
            {userData.leaveCode && <em> ({userData?.leaveCode[rowData.leaveType]?.title})</em>}
        </>)
    }
    const renderReasonOfLeave = (rowData, options) => {
        const reason = rowData.reasonOfLeave || '';
        const txt = reason.substr(0, 200);
        return (<>
            <span className='noet'>{txt}</span>
        </>)
    }

    const viewLeave = (row, tabIndex = 0) => {
        setSelLeaves(row);
        setViewDialog(true);
        setViewTabIndex(tabIndex)
    }

    const renderActions = (rowData, options) => {
        return (
            <div className='action-column'>
                {rowData.attachment !== null && <Button icon="pi pi-link" className="p-button p-button-text p-button-sm p-button-warning p-0 m-0" onClick={() => viewLeave(rowData, 1)} />}
                <Button icon="pi pi-eye" className="p-button-rounded p-button-text" aria-label="Edit" onClick={() => viewLeave(rowData, 0)} />
            </div>
        )
    }
    const updateLeaves = (e) => {
        setAction(e);
        setShowDialog(true)
    }
    const paginatorTmpl = {
        layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
        'RowsPerPageDropdown': (options) => {
            const dropdownOptions = [
                { label: 10, value: 10 },
                { label: 20, value: 20 },
                { label: 50, value: 50 }
            ];

            return (
                <React.Fragment>
                    <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Items per page: </span>
                    <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
                </React.Fragment>
            );
        },
        'CurrentPageReport': (options) => {
            return (

                <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
                    {options.first} - {options.last} of {options.totalRecords}
                </span>
            )
        }
    }
    const paginationLeft = (e) => {
        return (<div className='ess-header-label pt-1'>
            {['REVIEW'].includes(selStatus) && <>
                <Button label="Approve All" disabled={selectedLeave.length === 0} className="p-button-primary p-button-sm ml-2" icon="pi pi-check" onClick={() => updateLeaves('APPROVE')} />
                <Button label="Reject All" disabled={selectedLeave.length === 0} className="p-button-danger p-button-sm ml-2" icon="pi pi-trash" onClick={() => updateLeaves('REJECT')} />
            </>}

        </div>)
    }
    const updateLeaveById = (reason) => {
        const LEAVE_STATUS = (action === 'APPROVE' ? 'APPROVED' : 'REJECTED');
        try {
            const leaveReason = reason === '' ? LEAVE_STATUS : reason;
            const ids = selectedLeave.map(x => x.id);
            const payload = { leaves: ids, status: LeaveStatus[LEAVE_STATUS], reason: leaveReason };
            if (ids.length > 0) { // Check if there are any leaves to process
                leaveService.approveRejectLeaveByManager([payload]).then(resp => {
                    const body = resp?.data ?? resp;
                    if (body?.success === false) {
                        // do NOT run the success flow, show the exact backend error instead.
                        toast.error(body.error || "Unable to " + LEAVE_STATUS.toLocaleLowerCase() + " leave");
                        return;
                    }
                    toast.success("Leaves have been " + LEAVE_STATUS.toLocaleLowerCase());
                    setSelectedLeave([])
                    fetchReviewLeavesByUser();
                }).catch(err => {
                    const errBody = err?.response?.data ?? err?.data ?? {};
                    const errMsg = errBody.error || "Unable to " + LEAVE_STATUS.toLocaleLowerCase() + " leave";
                    toast.error(errMsg);
                });
            }
        } catch (error) {
            toast.error("Unable to approve leave");
        }
    }
    const shiftResource = (act) => {
        try {
            const selUserIndex = usersBySuperior.findIndex(user => user.id === selectedUser.id);
            if (!selectUser) {
                setSelectedUser(usersBySuperior[0]);
                return;
            }
            if (act === 'NEXT') {
                if (selUserIndex === usersBySuperior.length - 1) {
                    setSelectedUser(usersBySuperior[0])
                } else {
                    setSelectedUser(usersBySuperior[selUserIndex + 1])
                }
            } else {
                if (selUserIndex === 0) {
                    setSelectedUser(usersBySuperior[usersBySuperior.length - 1])
                } else {
                    setSelectedUser(usersBySuperior[selUserIndex - 1])
                }
            }
        } catch (error) {
            setSelectedUser(usersBySuperior[0]);
        }


    }
    return (
        <div className='ess-page user-leave p-2'>
            <div className='grid ess-grid-header'>
                <div className='col'>
                    <div className='form-control'>
                        <strong className='mr-3'>Resource Name </strong>
                        <Dropdown className="user-options capitalize" filter
                            value={selectedUser} options={usersBySuperior} onChange={(e) => setSelectedUser(e.target.value)}
                            optionLabel="name" placeholder="Select a User"
                        />
                    </div>
                    <div className='form-control'>
                        <strong className='mr-3'>Leave Status </strong>
                        <Dropdown className="user-status-options capitalize" placeholder="Select a status"
                            options={leaveStatuses} value={selStatus} onChange={(e) => setSelStatus(e.target.value)}
                        />
                    </div>
                </div>
                <div className='col-fixed' style={{ width: '100px', textAlign: 'right' }}>
                    <Button icon='pi pi-arrow-left' className='p-button mr-2' onClick={() => shiftResource('PREVIOUS')} />
                    <Button icon='pi pi-arrow-right' className='p-button' onClick={() => shiftResource('NEXT')} />
                </div>
            </div>
            <div className='grid'>
                <div className='col p-0 pt-2'>
                    {leaves && <>
                        <DataTable
                            className="leaves-data"
                            paginator
                            responsiveLayout="scroll"
                            paginatorLeft={paginationLeft}
                            paginatorTemplate={paginatorTmpl}
                            rows={10}
                            rowsPerPageOptions={[10, 20, 50]}
                            dataKey="id"
                            ref={dt}
                            value={leaves.filter(r => r.status == LeaveStatus[selStatus])}
                            selection={selectedLeave}
                            onSelectionChange={(e) => setSelectedLeave(e.value)}
                            resizableColumns
                            columnResizeMode="fit"
                            scrollable="horizontal"
                            stripedRows
                            editMode="row"
                        >
                            {selStatus === 'REVIEW' && <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />}
                            <Column field="startDate" header="Date" headerStyle={{ width: '100px' }} body={(rowData) => (utitService.dateWithMonthConverter(rowData.startDate))} />
                            <Column header="Day" headerStyle={{ width: '100px' }} body={(rowData) => (utitService.dateParser(rowData.startDate, 'dddd'))} />
                            <Column field="absenceCode" header="Absence Code" headerStyle={{ width: '220px' }} body={renderAbsenceCode} />
                            <Column field="leaveType" header="Leave Type" headerStyle={{ width: '180px' }} body={renderAbsenceDuration} />
                            <Column field="reasonOfLeave" header="Reason of leave" body={renderReasonOfLeave} />
                            <Column header="Actions" headerClassName='center-header' headerStyle={{ width: '10px', textAlign: 'center' }} bodyStyle={{ textAlign: 'right' }} body={renderActions} />
                        </DataTable>
                    </>}
                </div>
            </div>
            {ViewLeave({ visible: viewDialog, onHide: () => setViewDialog(false), style: { width: '900px' }, leave: selLeaves, header: 'Leave Details', tabIndex: viewTabIndex })}
            <ConfirmBox title={action === 'APPROVE' ? 'Approve' : 'Reject'}
                message={action === 'APPROVE' ? 'You can mention leave approval note here.' : 'You can mention leave rejection reason here.'}
                placeholder={'Enter note for ' + (action === 'APPROVE' ? 'approval' : 'rejection') + '.'}
                visible={showDialog} onCancel={() => setShowDialog(false)} onConfirm={updateLeaveById} />
        </div >
    )
}

export default ManagerUserLeaves